import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "./classPageTour.css";

/**
 * Tour cho /elearning/classes.
 * Các bước gắn [data-tour] tại: header, cụm icon hướng dẫn, filter, bảng danh sách.
 */
export function startClassPageTour() {
  const steps = [
    {
      popover: {
        title: "Hướng dẫn nhanh",
        description:
          "Giới thiệu các vùng chính của trang Lớp học: bộ lọc, bảng dữ liệu và cụm nút hướng dẫn ở góc phải tiêu đề.",
        side: "over",
        align: "center",
      },
    },
  ];

  const segments = [
    {
      selector: '[data-tour="classes-header"]',
      title: "Tiêu đề trang",
      description:
        "Đây là màn quản lý lớp học. Số lượng lớp đang hiển thị sẽ thay đổi theo bộ lọc và phân trang.",
      side: "bottom",
    },
    {
      selector: '[data-tour="classes-header-guides"]',
      title: "Nút hướng dẫn",
      description:
        "Hai icon bên phải: icon lấp lánh mở tour nhanh, icon dấu hỏi mở tài liệu hướng dẫn chi tiết (HTML).",
      side: "left",
    },
    {
      selector: '[data-tour="classes-filter"]',
      title: "Bộ lọc lớp học",
      description:
        "Tìm theo từ khóa, lọc theo khóa học/trạng thái và thao tác import/export để quản lý danh sách nhanh hơn.",
      side: "bottom",
    },
    {
      selector: '[data-tour="classes-table"]',
      title: "Bảng danh sách",
      description:
        "Bấm vào một dòng để xem chi tiết lớp, cập nhật trạng thái, chỉnh sửa hoặc xóa khi có quyền.",
      side: "top",
    },
  ];

  for (const seg of segments) {
    const el = document.querySelector(seg.selector);
    if (!el) continue;
    steps.push({
      element: el,
      popover: {
        title: seg.title,
        description: seg.description,
        side: seg.side,
      },
    });
  }

  if (steps.length <= 1) {
    window.alert(
      "Chưa tải được các vùng giao diện để hướng dẫn. Hãy tải lại trang và thử lại."
    );
    return;
  }

  const d = driver({
    showProgress: true,
    smoothScroll: true,
    stagePadding: 10,
    stageRadius: 14,
    overlayOpacity: 0.68,
    overlayColor: "#0f172a",
    popoverClass: "class-page-tour-popover",
    onPopoverRender: (popover) => {
      popover.wrapper?.setAttribute?.("lang", "vi");
    },
    nextBtnText: "Tiếp",
    prevBtnText: "Trước",
    doneBtnText: "Xong",
    progressText: "Bước {{current}} / {{total}}",
    showButtons: ["next", "previous", "close"],
    steps,
  });

  d.drive();
}
